
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              おかやま不動産販売株式会社
            </h3>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                〒700-0000 岡山市北区○○町1-2-3
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                TEL: 086-012-3456
              </p>
              <p className="flex items-center">
                <i className="ri-printer-line mr-2"></i>
                FAX: 086-012-3457
              </p>
              <p className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                営業時間: 9:00〜18:00
              </p>
              <p className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                定休日: 日曜日・祝日
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">サイトマップ</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/" className="hover:text-blue-400 transition-colors">ホーム</a></li>
              <li><a href="/services" className="hover:text-blue-400 transition-colors">事業内容</a></li>
              <li><a href="/about" className="hover:text-blue-400 transition-colors">会社概要</a></li>
              <li><a href="/careers" className="hover:text-blue-400 transition-colors">求人情報</a></li>
              <li><a href="/blog" className="hover:text-blue-400 transition-colors">ブログ・新着情報</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">サービス</h4>
            <ul className="space-y-2 text-gray-300">
              <li>不動産売買</li>
              <li>不動産買取</li>
              <li>無料査定</li>
              <li>売却相談</li>
              <li>購入相談</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 おかやま不動産販売株式会社. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="hover:text-blue-400 transition-colors ml-2">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
